import { useState, useEffect } from 'react';
import { useNavigate, useLocation, Outlet } from 'react-router';
import { getDefaultRouter } from '../utils';

const disabledRouters = ['/marketplace/'];

export const AutoSignin = ({ disabled = false }: { disabled?: boolean }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const user = localStorage.getItem('user');

    if (!user) return setIsLoading(false);

    if (
      !location.pathname.includes('/dashboard') &&
      !disabledRouters.some((route) => location.pathname.startsWith(route))
    ) {
      const path = getDefaultRouter();

      navigate(path);
    }
    setIsLoading(false);
  }, []);

  if (!isLoading || disabled)
    return (
      <>
        <Outlet />
      </>
    );

  return <></>;
};
